import React, { useEffect, useState, useContext } from "react";
import { AnalyticsContext } from "../../../context/analytics-context";
import { ReaderItem } from "../../../models/reader";
import { UserItem } from "../../../models/user";
import useInterval from "../../../hooks/useInterval";
import { HeroSection } from "./book_hero";
import { Link } from "react-router-dom";

type BookInfoProps = {
  reader: ReaderItem;
  goBack: any;
  playVideo?: any;
  user: UserItem;
  row_title: string;
};

const BookInfo: React.FC<BookInfoProps> = ({
  reader,
  goBack,
  user,
  row_title,
}) => {
  const [viewTimer, setViewTimer] = useState(0);
  const analyticsContext = useContext(AnalyticsContext);

  useEffect(() => {
    // save event to google analytics
    const event = {
      category: "Reader",
      action: "LibraryView",
      label: `${reader.id}`,
      value: 1,
    };
    analyticsContext.event(event);

    return () => {
      // save event to google analytics
      const event = {
        category: "Reader",
        action: "TimeSpentLibrary",
        label: `${reader.id}`,
        value: viewTimer,
      };
      if (viewTimer) {
        analyticsContext.event(event);
      }
      setViewTimer(0);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reader]);

  useInterval(() => {
    if (document.hasFocus()) {
      setViewTimer((viewTimer) => viewTimer + 1);
    }
  }, 1000);

  const triggerClick = (ev: any) => {
    const action = ev.target.dataset.action;
    if (!action) return;
    const event = {
      category: "Reader",
      action: action,
      label: `${reader.id}`,
      value: 1,
    };
    analyticsContext.event(event);
  };

  return (
    <div className="book_info" id="book_info">
      <NavBar onBack={goBack} row_title={row_title} reader={reader} />
      <HeroSection
        book={reader}
        triggerClick={triggerClick}
        is_teacher={user.is_teacher}
      />
    </div>
  );
};

interface NavBarProps {
  onBack?: () => void;
  row_title: string;
  reader: ReaderItem;
}

const NavBar: React.FC<NavBarProps> = ({ onBack, row_title, reader }) => {
  return (
    <nav>
      <button className="btn btn-info mr-3" onClick={onBack}>
        <span className="backChevron mr-2">‹</span> Back to Library
      </button>
      <h5 className="ml-1 navTitle m-0 text-white keep-color">{row_title}</h5>
      <div className="spacer" />
      <Link to={`/rate/${reader.url}/${reader.id}`} className="rateBtn">
        <span className="mr-2">☆</span> Rate This Book
      </Link>
    </nav>
  );
};

export default BookInfo;
